import styled from "styled-components";
import loginBackgroung from "../../Assets/loginBackgroung.svg";

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 120px;
  background-image: url(${loginBackgroung});
  background-repeat: no-repeat;
  background-size: 70vw;
  background-position-x: right;
  background-position-y: center;
  @media (min-width: 768px) {
    padding-top: 150px;
  }
`;

export const FormContainer = styled.div`
  height: 400px;
  display: flex;
  align-items: center;
`;
